import { createFileRoute } from '@tanstack/react-router'
import WorkTeam from 'Work/components/Work/Sections/Team/WorkTeam'

export const Route = createFileRoute('/work/$workId/team')({
    component: WorkTeam,
})
